import { Box } from "@chakra-ui/react"

const StateBox: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Box bg="white" p={8} borderRadius="lg" boxShadow="md" textAlign="center">
    {children}
  </Box>
)

export default StateBox
